export default __webpack_public_path__ + "static/telco-1-c626e5c6509924389a597cc3a4ac6403.png";